export class SealevelInstructionWrapper {
    fields;
    instruction;
    data;
    constructor(fields) {
        this.fields = fields;
        Object.assign(this, fields);
    }
}
export class SealevelAccountDataWrapper {
    fields;
    initialized;
    discriminator;
    data;
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(fields) {
        this.fields = fields;
        Object.assign(this, fields);
    }
}
export function getSealevelAccountDataSchema(DataClass, discriminator) {
    return {
        kind: 'struct',
        fields: [
            ['initialized', 'u8'],
            ...(discriminator ? [['discriminator', discriminator]] : []),
            ['data', DataClass],
        ],
    };
}
//# sourceMappingURL=sealevelSerialization.js.map